// import {
//   getLoginShopid,
// } from '@RootCommon/utils'
import { commonRequest } from '../utils/request'
import mainApi from '@/common/api/urls'

// 获取门店列表，依赖acctId, 账号相关的i18n信息就绪
export async function getRbacAuthResourceApi (params: {
  shopId: number,
}) {
  return commonRequest.post(mainApi.rbacAuthResource, {
    ...params,
    // shopId, // 首次登录还没有缓存的shopid, 全部门店传0或不传
  }, { autoToast: false })
}